import styled from 'styled-components';
import sizes from 'styles/sizes';
import { BrandCode } from 'types';

export const CruiseCardPriceBase = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	justify-content: center;
	${({ theme }) =>
    ({
      [BrandCode.Celebrity]: `
      align-items: center;
      gap: 10px;
      margin-bottom: 20px;
      
      @media (min-width: ${sizes.media.tabletPortrait}px) {
        align-items: flex-start;
        gap: 10px;
        justify-content: center;
        margin-bottom: 0;        
      }

      @media (min-width: ${sizes.media.tabletLandscape}px) {
        align-items: center;
        gap: 5px;
      }

      @media (min-width: ${sizes.media.mediumMaxWidth}px) {
        align-items: flex-start;
        gap: 10px;
      }
    `,
      [BrandCode.RoyalCaribbean]: `
      align-items: center;
      gap: 10px;
      margin-bottom: 10px;

      @media (min-width: ${sizes.media.tabletPortrait}px) {
        align-items: flex-start;
        margin-bottom: 0;
      }

      @media (min-width: ${sizes.media.mediumMaxWidth}px) {
        gap: 15px;
      }
    `,
    })[theme.brandCode]}
`;

export const CruiseCardPriceLabel = styled.p`
	font-family: ${({ theme }) => theme.typography.fontFamilySemiBold};
	text-transform: uppercase;
	${({ theme }) =>
    ({
      [BrandCode.Celebrity]: `
      color: ${theme.palette.text.secondary};
      font-size: 12px;
      letter-spacing: 0.24px;
      line-height: 18px;
    `,
      [BrandCode.RoyalCaribbean]: `
      color: ${theme.palette.grey[800]};
      font-size: 10px;
      letter-spacing: 0.6px;
      line-height: 12px;

      @media (min-width: ${sizes.media.mediumMaxWidth}px) {
        font-size: 12px;
        letter-spacing: 0.72px;
        line-height: 15px
      }
    `,
    })[theme.brandCode]}
`;

export const CruiseCardPriceTag = styled.div`
	align-items: flex-start;
	color: ${({ theme }) => theme.palette.text.primary};
	display: flex;
	flex-direction: row;
	font-family: ${({ theme }) => theme.typography.price1.fontFamily};
	justify-content: flex-start;
	${({ theme }) =>
    ({
      [BrandCode.Celebrity]: `
      font-feature-settings: 'pnum' on,'lnum' on;
    `,
      [BrandCode.RoyalCaribbean]: '',
    })[theme.brandCode]}
`;

export const CruiseCardPriceCurrency = styled.span`
	text-align: right;
	${({ theme }) =>
    ({
      [BrandCode.Celebrity]: `
      color: ${theme.palette.primary.main};
      font-size: 18px;
      letter-spacing: -0.36px;
      line-height: 94%;
    `,
      [BrandCode.RoyalCaribbean]: `
      font-size: 26px;
      letter-spacing: -0.52px;
      line-height: 50%;

      @media (min-width: ${sizes.media.tabletPortrait}px) {
        line-height: 42%;
      }

      @media (min-width: ${sizes.media.tabletLandscape}px) {
        line-height: 47%;
      }

      @media (min-width: ${sizes.media.mediumMaxWidth}px) {
        font-size: 32px;
        letter-spacing: -0.64px;
        line-height: 54%;
      }
    `,
    })[theme.brandCode]}

	&.left {
		order: 0;
	}

	&.right {
		order: 1;
	}
`;

export const CruiseCardPriceValue = styled.span`
	text-align: right;
	text-transform: uppercase;
	${({ theme }) =>
    ({
      [BrandCode.Celebrity]: `
      color: ${theme.palette.primary.main};
      font-size: 42px;
      letter-spacing: -0.84px;
      line-height: 72%;

      &.complimentary {
        font-size: 32px;
        letter-spacing: -0.64px;
      }
    `,
      [BrandCode.RoyalCaribbean]: `
      font-size: 52px;
      letter-spacing: -1.04px;
      line-height: 58%;

      @media (min-width: ${sizes.media.tabletPortrait}px) {
        font-size: 64px;
        letter-spacing: -1.28px;
        line-height: 58%;
      }

      @media (min-width: ${sizes.media.tabletLandscape}px) {
        font-size: 52px;
      }

      @media (min-width: ${sizes.media.mediumMaxWidth}px) {
        font-size: 64px;
        letter-spacing: -1.28px;
      }

      &.complimentary {
        font-size: 40px;
        line-height: 80%;
        letter-spacing: -0.8px;
      }
    `,
    })[theme.brandCode]}
`;

export const CruiseCardOccupancyLabel = styled.p`
	font-family: ${({ theme }) => theme.typography.fontFamilySemiBold};
	text-transform: uppercase;
	font-size: 12px;
	${({ theme }) =>
    ({
      [BrandCode.Celebrity]: `
      color: ${theme.palette.text.secondary};
      letter-spacing: 0.24px;
      @media (max-width: ${sizes.media.mediumMinWidth}px) {        
        text-align: center;
      }
    `,
      [BrandCode.RoyalCaribbean]: `
      color: ${theme.palette.grey[800]};
      letter-spacing: 0.6px;

      @media (min-width: ${sizes.media.mediumMaxWidth}px) {
        letter-spacing: 0.72px;
      }

      @media (max-width: ${sizes.media.mediumMinWidth}px) {
        font-size: 10px;
        text-align: center;
      }

      
    `,
    })[theme.brandCode]}
`;

export const CruiseCardPriceContainer = styled.div`
	font-family: ${({ theme }) => theme.typography.fontFamilySemiBold};
	text-transform: uppercase;
	${({ theme }) =>
    ({
      [BrandCode.Celebrity]: `
      color: ${theme.palette.text.secondary};
      font-size: 12px;
      letter-spacing: 0.24px;
      line-height: 18px;
    `,
      [BrandCode.RoyalCaribbean]: `
      color: ${theme.palette.grey[800]};
      font-size: 10px;
      letter-spacing: 0.6px;
      line-height: 12px;

      @media (min-width: ${sizes.media.mediumMaxWidth}px) {
        font-size: 12px;
        letter-spacing: 0.72px;
        line-height: 15px
      }
    `,
    })[theme.brandCode]}
`;
